import { render, staticRenderFns } from "./SettingsNotificationSmsKey.vue?vue&type=template&id=2abd1868&"
import script from "./SettingsNotificationSmsKey.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationSmsKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports